var transactionLock = false;
$(function(){
  $('.timestamp').each(function(){
    processTimestamp(this);
  });
  $(document.body).on('click','.loadRadioPlayer',function(e){
    e.preventDefault();
    centeredPopup($(this).attr('href'),465,860);
  });
});
function processTimestamp(item){
  $(item).css("display","inline");
  if($(item).hasClass('fullDate')){
    $(item).text(fullDate($(item).text()));
  } else {
    $(item).text(calculateTime($(item).text(),$(item)));
  }
}
$('#memberName').mouseover(function(){
  if(!$('#profileInfo').length) //Don't show the message on the profile page
    $('.statusDescriptionBox').show();
}).mouseout(function(){
  if(!$('#profileInfo').length)
    $('.statusDescriptionBox').hide();
})
// ------- SOCIAL HANDLER --------
$(document.body).on('click', '.socialLink', function (e) {
  e.preventDefault();
  var item = $(this);
  var socialParent = item.closest('.socialHolder');
  var url = socialParent.attr('data-url');
  if(url.indexOf('://')==-1) //NOTE: needed for sharing youtube urls.
    url = window.location.protocol + '//' + window.location.host + url;
  var title = socialParent.attr('data-title');
  var summary = socialParent.attr('data-summary');
  var image = socialParent.attr('data-image');
  if(item.hasClass('fbArticleLink'))
    social_click('facebook',url,title,image,summary);
  else if(item.hasClass('twArticleLink'))
    social_click('twitter',url,title,image,summary);
});
$.fn.hasAttr = function(attrName){
  if(typeof attrName !== 'string' || attrName === '') return false;
  var attr = this.attr(attrName);
  if(typeof attr !== 'undefined' && attr !== false)
    return true;
  return false;
}
function social_click(socialNetwork,url,title,image,summary){
  // Tag Manager - Social Share Event
  dataLayer.push({'event': 'Social Share', 'social_network': socialNetwork})

  var height = 368;
  var width = 640;
  var leftPosition, topPosition, windowFeatures, url;
  //set popup in the middle of the screen
  leftPosition = (window.screen.width / 2) - ((width / 2) + 10);
  topPosition = (window.screen.height / 2) - ((height / 2) + 50);
  windowFeatures = "status=no,height=" + height + ",width=" + width + ",resizable=yes,left=" + leftPosition + ",top=" + topPosition + ",screenX=" + leftPosition + ",screenY=" + topPosition + ",toolbar=no,menubar=no,scrollbars=no,location=no,directories=no";       
  url += "?utm_source=" + socialNetwork + "&utm_campaign=siteSharer"; //NOTE: attribution tracking
  if(socialNetwork == "facebook") //NOTE: http://stackoverflow.com/questions/14377968/cant-use-facebook-sharer-php-custom-parameters-in-mobile-sites
    url = 'http://www.facebook.com/sharer.php?m2w&s=100&p[title]=' + encodeURIComponent(title) + '&p[summary]=' + encodeURIComponent(summary) + '&p[url]=' + encodeURIComponent(url) + "&t=" + encodeURIComponent(title) + "&u=" + encodeURIComponent(url);
  if(socialNetwork == "twitter")
    url = 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(title) + '&url=' + encodeURIComponent(url);
  window.open(url,"_blank",windowFeatures);
  return false;
}
function acljScrollTo(id, offset){
  var top = 0
  if($(id).length !== 0){
    top = $(id).offset().top // Temporary workaround when nested in marko header
  }
  $('html, body').animate({scrollTop: top + (offset || 0)}, 1000);
}
function fullDate(timestamp){
  var d = new Date(parseInt(timestamp));
  var months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
  return months[d.getMonth()] + " " + d.getDate() + ", " + d.getFullYear();
}
function calculateTime(timestamp,obj){
  var min=1000*60;
  var hr=min*60;
  var day=hr*24;
  var yr=day*365;
  var d = new Date();
  var p = timestamp;

  var pubT = d.getTime() - p;

  var years = Math.floor(pubT / yr);
  var months = Math.floor(pubT / day / 30);
  var days = Math.floor(pubT / day);
  var hours = Math.floor(pubT / hr);
  var minutes = (pubT / min > 1) ? Math.floor(pubT / min) : 1;
  if(typeof obj != 'undefined' && obj.parents('#featuredContent').length){  
    if (years > 1)
      return years + ' years ago';
    if (months >= 1)
      return months + ((months > 1) ? ' months ago' : ' month ago');
    if (days >= 1)
      return (days > 1) ? days + ' days ago' : ' yesterday';
    if (hours >= 1)
      return hours + ((hours > 1) ? ' hours ago' : ' hour ago');
    return minutes + ((minutes > 1) ? ' minutes ago' : ' minute ago');
  } else {
    if (years > 1)
      return years + ' yrs. ago';
    if (months >= 1)
      return months + ((months > 1) ? ' months ago' : ' month ago');
    if (days >= 1)
      return (days > 1) ? days + ' days ago' : ' yesterday';
    if (hours >= 1)
      return hours + ((hours > 1) ? ' hrs. ago' : ' hr. ago');
    return minutes + ((minutes > 1) ? ' mins. ago' : ' min. ago');
  }
}
function centeredPopup(url,width,height){
  var leftPosition, topPosition, windowFeatures;
  //set popup in the middle of the screen
  leftPosition = (window.screen.width / 2) - ((width / 2) + 10);
  topPosition = (window.screen.height / 2) - ((height / 2) + 50);
  
  windowFeatures = "status=no,height=" + height + ",width=" + width + ",resizable=no,left=" + leftPosition + ",top=" + topPosition + ",screenX=" + leftPosition + ",screenY=" + topPosition + ",toolbar=no,menubar=no,scrollbars=yes,location=no,directories=no";
  window.open(url,"popupWindow",windowFeatures);
  return false;
}
function initializeCounter(obj,petitionId){
      var initialized = false;
      var totalCount = 0;
      var url, dataType;
      url = "/Petitions/GetSignatureCountById";
      
      var changeCounter = setInterval(function(){
            updateCounter();
      },30000);
      updateCounter();

      function updateCounter(){
        $.ajax({
               url: url,
               data: {petitionId:petitionId}, 
               success: function(data){
                     if(!initialized){
                           totalCount = parseInt(data.Count);
                           obj.text(addCommas(totalCount));
                           initialized = true;
                     } else {
                           var temp = totalCount;
                           totalCount = parseInt(data.Count);
                           if (temp >= totalCount)
                                 return;
                           var incr = Math.round((totalCount - temp)/30);
                           if (incr == 0) {incr += 1;}
                           var animateCounter = setInterval(function(){
                                 obj.text(addCommas(temp));
                                 if (temp >= totalCount){
                                       obj.text(addCommas(totalCount));
                                       clearInterval(animateCounter);}
                                 else
                                       temp+=incr;
                                 },100);
                     }
               },
               /*error: function(XMLHttpRequest, textStatus, errorThrown) { 
                     alert("Status: " + textStatus); alert("Error: " + errorThrown);
               },*/  //Test function to isolate errors
               dataType: "json"
         });
    }
}
var addCommas = function (nStr) {
    nStr += '';
    var x = nStr.split('.');
    var x1 = x[0];
    var x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
}
//Cookies
var cookies = {
  getItem: function (sKey) {
    return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
  },
  setItem: function (sKey, sValue, vEnd, sPath, sDomain, bSecure, sameSite, httpOnly) {
    if(typeof sDomain == 'undefined' || sDomain === null) sDomain='.aclj.org';
    if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) { return false; }
    var sExpires = "";
    if (vEnd) {
      switch (vEnd.constructor) {
        case Number:
          sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; max-age=" + vEnd;
          break;
        case String:
          sExpires = "; expires=" + vEnd;
          break;
        case Date:
          sExpires = "; expires=" + vEnd.toUTCString();
          break;
      }
    }
    document.cookie = encodeURIComponent(sKey) + "=" + encodeURIComponent(sValue) + sExpires + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "") + (bSecure ? "; Secure" : "") + (sameSite ? "; SameSite=" + sameSite : "") + (httpOnly ? "; HttpOnly" : "");
    return true;
  },
  removeItem: function (sKey, sPath, sDomain) {
    if (!sKey || !this.hasItem(sKey)) { return false; }
    document.cookie = encodeURIComponent(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + ( sDomain ? "; domain=" + sDomain : "") + ( sPath ? "; path=" + sPath : "");
    return true;
  },
  hasItem: function (sKey) {
    return (new RegExp("(?:^|;\\s*)" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=")).test(document.cookie);
  }
};
//Query String Params
var queryString = {
  getQueryVariable:function(variable) { //http://stackoverflow.com/questions/2090551/parse-query-string-in-javascript
      var query = window.location.search.substring(1);
      var vars = query.split('&');
      for (var i = 0; i < vars.length; i++) {
          var pair = vars[i].split('=');
          if (decodeURIComponent(pair[0]) == variable) {
              return decodeURIComponent(pair[1]);
          }
      }
  }
}


// Petition widget code
function displayNextActivityForm(){
  var currentForm = $(".forms.current");
  var nextForm = currentForm.next();
  var currentSection = $(".sections a.current");
  var nextSection = currentSection.next();
  currentForm.removeClass('current')
  currentSection.removeClass('current');
  nextForm.addClass('current');
  nextSection.addClass('current');
  if(typeof fillInMemberInfo !== 'undefined')
    fillInMemberInfo(nextForm);
  else
    altFillInMemberInfo(nextForm);
}
$(".sections a").click(function(e){
  e.preventDefault();
  var sectionIndex = $('.sections a').index(this);
  var thisForm = $('.forms').get(sectionIndex);
  $('.forms').removeClass('current');
  $('.sections a').removeClass('current');
  $(this).addClass('current');
  $(thisForm).addClass('current');
  if(typeof fillInMemberInfo !== 'undefined')
    fillInMemberInfo(thisForm);
  else
    altFillInMemberInfo(thisForm);
})
function altFillInMemberInfo(form){
  var alt = {email: "ContactEmail",firstName:"FirstName",lastName:"LastName",zip:"zipcode"};
  var form = $(form);
  var memberInfo = fetchMemberInfo();
  if(memberInfo==null) return;
  for(var key in memberInfo){
    var input=form.find('input[name="' + key + '"],select[name="' + key + '"]');
    if(!input.length && alt[key]){
      input = form.find('input[name="' + alt[key] + '"],select[name="' + key + '"]');
    }
    input.val(memberInfo[key]);
		input.keyup();
    if(typeof fillInDonationFormInfo !== 'undefined'){
      fillInDonationFormInfo(key,memberInfo[key]);
    }
  }
}
function progressTiles(show, partial){
  var tiles = $('#memberName').find('.profileProgress');
  for(var i = 0; i < tiles.length; i++){
    if(typeof show !== 'undefined' && show == false){
      $(tiles[i]).hide();
    }else if(typeof show !== 'undefined' && show == true){
      verified(false);
      $('.statusDescriptionMessage').text("Click to complete your ACLJ Member Profile and receive a free gift!");
      if(partial && i == 2){   //Allows for toggling third tile if progress is partial
        $('.statusPercentage p').text("75%");
        if($(tiles[i]).hasClass('empty')){
          $(tiles[i]).removeClass('empty');
          $(tiles[i]).addClass('full');
        }
      }else if(!partial && i ==2){
        $('.statusPercentage p').text("50%");
        if($(tiles[i]).hasClass('full')){
          $(tiles[i]).removeClass('full');
          $(tiles[i]).addClass('empty');
        }
      }
      $(tiles[i]).show();
    }else{  //Defaults to empty status if show is undefined
      $(tiles[i]).show();
      $('.statusPercentage p').text("50%");
      $('.statusDescriptionMessage').text("Click to complete your ACLJ Member Profile and receive a free gift!");
      if($(tiles[2]).hasClass('full')){
        $(tiles[2]).removeClass('full');
        $(tiles[2]).addClass('empty');
      }
    }
  }
}
function verified(show){
  if(show){
    $('.verifiedCheck').show();
    $('.statusDescriptionText').hide();
    $('.statusDescriptionText.verified').show();
    $('.statusDescriptionMessage').text("You are a verified member. Click to edit your profile.");
  }else{
    $('.verifiedCheck').hide();
    $('.statusDescriptionText').show();
    $('.statusDescriptionText.verified').hide();
  }
}
function fillProfileInfo(){   //Attempt to fill in user profile information
  if($('#userProfile').length){
    var profile = $('#profileInfo');
    var memberInfo = fetchMemberInfo();
    if(memberInfo== null) return;
    var status = sharedFunctions.addressCompleted(memberInfo);
    if(status == 'empty' || status == 'partial'){
      var bars = $('#profileInfo .statusBarsContainer').find('.statusBar');
      $(bars[2]).removeClass('notFilled');
      $(bars[3]).removeClass('notFilled');
      $(bars[2]).addClass((status == 'empty')? 'notFilled' : 'filled');
      $(bars[3]).addClass('notFilled');
      $('.statusTextContainer').show();
      $('.statusTextContainer.verified').hide();
      $('#profileCompletionMessage').show();
      $('.arrowContainer .boxContainer').addClass('visible-xs');
      $('.arrowContainer .boxContainer').addClass('visible-sm');
      $('.arrowContainer .triangleBelowContainer').addClass('visible-xs');
      $('.arrowContainer .triangleBelowContainer').addClass('visible-sm');
      $('.arrowContainer .triangle').show();
      $('#profileSocial').removeClass('verified');
      $('.arrowContainer p').text("Fill out the form to upgrade your ACLJ Profile.");
      $('.statusAmount p').text((status == 'empty')? "50%" : "75%");
    }
    else{
      var bars = $('#profileInfo .statusBarsContainer').find('.statusBar');
      $(bars[2]).removeClass('notFilled');
      $(bars[3]).removeClass('notFilled');
      $(bars[2]).addClass('filled');
      $(bars[3]).addClass('filled');
      $('.statusTextContainer').hide();
      $('.statusTextContainer.verified').show();
      $('#profileCompletionMessage').hide();
      $('.arrowContainer .boxContainer').removeClass('visible-xs');
      $('.arrowContainer .boxContainer').removeClass('visible-sm');
      $('.arrowContainer .triangleBelowContainer').removeClass('visible-xs');
      $('.arrowContainer .triangleBelowContainer').removeClass('visible-sm');
      $('.arrowContainer .triangle').hide();
      $('#profileSocial').addClass('verified');
      $('.arrowContainer p').text("Thank you for completing your ACLJ profile");
    }
    $('#firstName').val(memberInfo.firstName || "");
    $('#lastName').val(memberInfo.lastName || "");
    var country = memberInfo.country || "US";
    fillAddressModal({
      street1: memberInfo.street1 || "",
      street2: memberInfo.street2 || "",
      city: memberInfo.city || "",
      state: memberInfo.state || ((country == 'US' || country == 'CA')? "NULL" : ""),
      zipcode: memberInfo.zip || ""
    });
    $('#email').val(memberInfo.email);
    if(memberInfo.phone1) $('#phone1').val(memberInfo.phone1);
    if(memberInfo.phone2) $('#phone2').val(memberInfo.phone2);
    $('#profileLogin').hide();
    $('#profileInfo').show();
  }
}
function fillAddressModal(address){
  for(var key in address){
    var item = $('#'+key);
    if(typeof item !== 'undefined'){
      var input = item.find('input');
      var select = item.find('select');
      if(input.length)
        input.val(address[key]);
      else if(select.length)
        select.val(address[key]);
    }
  }
}
function clearProfileInfo(){
  if($('#userProfile').length){
    $('#profileLogin').toggle();
    $('#profileInfo').toggle();
    $('#profileInfo #firstName').val("");
    $('#profileInfo #lastName').val("");
    $('#address').empty();
    $('#email').val("");
    $('#phone1').val("");
    $('#phone2').val("");
  }
}
function validateSignatureInteraction(email, cb){
	gRecordAction('signature', function(token){
		if(!token)
			return cb(false);
		$.ajax({
			type: 'POST',
			url: '/validate/recaptcha',
			data: { token: token, email: email },
			dataType: 'json',
			success: function(data){
				if(!data || !data.success){
					return cb(false);
				}
				return cb(true);
			}
		})
	})
}
$("#SignForm").submit(function(e){
  e.preventDefault();
  reportSignature();
  var form = this;
  $(form).find('input').each(function(){trimInput(this)}); // Trim all leading and trailing whitespace from input values
  validateForm(form, function(valid){
    if (!valid){
      return;
    }
    var petitionId = document.forms["SignForm"]["petitionId"].value;
    var email = document.forms["SignForm"]["email"].value;
    var data = $(form).serialize();
    var url = "";
    saveMemberInfoFromQueryString(data);
    url = $(form).attr('action');
    successDisplay("Thank you!","Your signature has been successfully submitted.");
    validateSignatureInteraction(email, function(validReCaptcha){
      if(!validReCaptcha) {
        // Invalid submission. We don't actually want to tell the user/bot that it errored.
        return displayNextActivityForm();
      }
      $.ajax({
        type:"POST",
        url: url,
        data: data,
        success: function(data){
          if(data.success){
            displayNextActivityForm();
            dataLayer.push({'event': 'Signature', 'petition_id': petitionId}) // Google Tag Manager 'Signature' Trigger
            if(data.newMember) {
              dataLayer.push({'event': 'New Member','eid': email}) // Google Tag Manager 'New Member' Trigger
            }
          }else{
            //TODO: stop and explain the errors.
          }
        },
        dataType: "json"
      });
    })
  });
});
function reportSignature(){
  //google adwords report
  goog_report_sigAdwords();
  //google analytics report
  //facebook report
  dataLayer.push({'event': 'Petition', 'petition_id': document.forms["SignForm"]["petitionId"].value}) // Google Tag Manager 'Petition' Trigger
  //reddit report
  redditConversion();
}
$('.connectForm').submit(function(e){
  e.preventDefault();
  dataLayer.push({'event': 'Email List Subscribed'}) // Google Tag Manager 'Email List Subscribed' Trigger
  var form = this;
  performSignUp(form, function(success){
    if(!success) return;
    successDisplay("Thank you!","You have been signed up for email updates.");
  })
})
$('.foiaForm').submit(function(e){
  e.preventDefault();
  var form = this;
  performSignUp(form, function(success){
    if(!success) return;
    dataLayer.push({'event': 'Email List Subscribed'}) // Google Tag Manager 'Email List Subscribed' Trigger
    dataLayer.push({'event': 'Email List FOIA Subscribed'}) // Google Tag Manager 'Email List Foia Subscribed' Trigger
    $('#foia-form').hide();
    $('#foia-download').show();
    $('#foia-download').submit(); //Attempt to download the file automatically
  })
})
function performSignUp(form, cb){
  validateForm(form, function(valid){
    if(!valid) return cb(false);
    $(form).find('input').each(function(){trimInput(this)}); // Trim all leading and trailing whitespace from input values
    var data = $(form).serialize();
    var url = $(form).attr('action');
    saveMemberInfoFromQueryString(data);
    
    $.ajax({
      type: 'POST',
      url: url,
      data: data,
      success: function(data){
        if(data.success){
          return cb(true);
        }
        return cb(false);
      },
      error: function(){
        return cb(false);
      }
    })
  })
}
$('body').on('blur','.validate',function(e){
  if($(this).attr('name') == 'email'){
    $(this).val($(this).val().replace(/\s/g,''));
  }
  validate(this);
});
$('input[name="email"]').on('input',function(e){
  removeError(this);
});
function validate(field){
  var valid=true;
  field = $(field);
  removeError(field);
  var validationRules = field.attr('data-validation-rules').split(" ");
  //First check if it's required and empty
  if($.inArray("required",validationRules)!=-1 && ( field.val() === null || field.val() === "" || field.val() == "UNANSWERED_PLEASECHOOSE")){
    displayError(field,"This field is required");
    valid=false;
  }
  if($.inArray("email",validationRules)!=-1 && !validEmail(field.val())){
    displayError(field,"Invalid Email Address");
    valid=false;
  }
  if($.inArray("state",validationRules) != -1 && !validState(field.find('option:selected').text())){
    displayError(field,"Please Select a State");
    valid = false;
  }
  if($.inArray("zip",validationRules)!=-1 && !validZip(field.val())){
    displayError(field,"Invalid Zip Code");
    valid=false;
  }
  if($.inArray("donation",validationRules)!=-1 && !validDonation(field)){
      errorDisplayAndTrack('Please select/enter a donation amount greater than $5');
      valid=false;
  }
  return valid;
}
function removeError(field){
  field = $(field);
  var holder = field.closest('.form-group');
  holder.removeClass('has-error');
  var helpBlock = holder.find('.help-block');
  helpBlock.text("");
  helpBlock.hide();
}
function displayError(field,msg){
  field = $(field);
  var holder = field.closest('.form-group');
  holder.addClass('has-error');
  var helpBlock = holder.find('.help-block');
  helpBlock.text(msg);
  helpBlock.show();
}
function validateForm(form, exclusions, callback){
  if(typeof callback === "undefined"){
    callback = exclusions;
    exclusions = [];
  }
  form = $(form);
  var valid = true;
  form.find('.validate').each(function(i){
    var excluded=false;
    for(var i=0;i<exclusions.length;i++){
      var exclusion = exclusions[i];
      if($(this).hasClass(exclusion))
        excluded=true;
    }
    if(!excluded)
      if(!validate(this)){
        valid=false;
      }
  });
  callback(valid);
}
function validEmail(email){
  //return email !== null && email !== "";
  //var re = /[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+(?:[A-Za-z]{2}|com|org|net|gov|mil|biz|info|mobi|name|aero|jobs|museum|edu)\b/;
  var re = /^[A-Z0-9._%+-]+@(?:[A-Z0-9-]+\.)+[A-Z]+$/i
  return re.test(email);
}
function validState(state){return state !== '-State-' && state !== '-Select State-'}
function validZip(zip){
  //var re = /^\d{5}(-\d{4})?$/;
  //return re.test(zip);
  if(typeof zip !== "undefined" && zip !== null && zip !== "")
    return true;
  return false;
}
function validDonation(donationHolderDiv){
  return getDonationAmount($(donationHolderDiv))>=5
}
/**
 * Trim the whitespace from both sides of an input's value.
 */
function trimInput(input){
  try {
    if(typeof input === 'undefined')
      input = this;
    input = $(input);
    var trimmedVal = input.val().trim();
    input.val(trimmedVal);
    return
  } catch (err) {
    return
  }
}
function handleError(errorElem){
  errorElem = $(errorElem);
  var errorElemId = errorElem.attr('id');
  var kimbiaMsg=errorElem.find('.k_messages').text();
  if(errorElemId.indexOf('DonationLevel') != -1){
    errorDisplayAndTrack(kimbiaMsg);
    return true;
  }else if(errorElemId.indexOf('Email') != -1){
    var acljElem=errorElem.parents('.kimbiaDonationForm').find('.email.form-control');
  }else if(errorElemId.indexOf('First') != -1){
    var acljElem=errorElem.parents('.kimbiaDonationForm').find('.firstName.form-control');
  }else if(errorElemId.indexOf('Last') != -1){
    var acljElem=errorElem.parents('.kimbiaDonationForm').find('.lastName.form-control');
  }else if(errorElemId.indexOf('street1') != -1){
    var acljElem=errorElem.parents('.kimbiaDonationForm').find('.street1.form-control');
  }else if(errorElemId.indexOf('street2') != -1){
    var acljElem=errorElem.parents('.kimbiaDonationForm').find('.street2.form-control');
  }else if(errorElemId.indexOf('state') != -1){
    var acljElem=errorElem.parents('.kimbiaDonationForm').find('.state.form-control');
  }else if(errorElemId.indexOf('city') != -1){
    var acljElem=errorElem.parents('.kimbiaDonationForm').find('.city.form-control');
  }else if(errorElemId.indexOf('zip') != -1){
    var acljElem=errorElem.parents('.kimbiaDonationForm').find('.zip.form-control');
  }else if(errorElemId.indexOf('accountNumber') != -1){
    var acljElem=errorElem.parents('.kimbiaDonationForm').find('.accountNumber.form-control');
  }else if(errorElemId.indexOf('verification') != -1){
    var acljElem=errorElem.parents('.kimbiaDonationForm').find('.verification.form-control');
  }else if(errorElemId.indexOf('monthExpires') != -1){
    var acljElem=errorElem.parents('.kimbiaDonationForm').find('.expirationMonth.form-control');
  }else if(errorElemId.indexOf('yearExpires') != -1){
    var acljElem=errorElem.parents('.kimbiaDonationForm').find('.expirationYear.form-control');
  }else{
    return false;
  }
  displayError(acljElem,kimbiaMsg);
  return true;
}

function showBackupDonationMethod(){
  hideStoredTokenForm();
  $('#SubmitButton').hide();
  $('#CreditCardForm').removeClass('maximized');
  $('#PaypalButton').show();
  $('#PaymentProcessorSelection').hide();
}
function confirmDonationThreshold(amount, cb){
  var thresholdAmount = 1000;
  if(amount >= thresholdAmount){
    var formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })
    var amountFormatted = formatter.format(amount);
    swal({
      title: "Thank You!",
      text: "Please confirm your " + amountFormatted + " donation to ACLJ. (We want to make sure that this wasn't an accident)",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#657492",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      closeOnConfirm: true,
      closeOnCancel: true
    }, function(yes){
      if(yes) cb(true);
      else cb(false);
    })
  }else{
    cb(true);
  }
}
function onKimbiaPlatformSubmissionResponse(obj){}
function onKimbiaAfterSubmit(obj){}
function saveDonation(charge,topicTag,recurring,giftTopic){
  var data = {charge:charge,isRecurring:recurring,topicTag:topicTag};
  if(giftTopic) data.giftTopic = giftTopic;
  $.ajax({
    type:"POST",
    url: '/donate/save-donation',
    data: data,
    success: function(data){
      if(data.success){
        //TODO: do something on success.
      }else{
        //TODO: stop and explain the errors.
      }
    },
    dataType: "json"
  });
}
function getAppealCode(){
  if(typeof callCenterAppealCode !== "undefined" && callCenterAppealCode !== null)
    return callCenterAppealCode;
  var now = new Date();
  var appealCodeDate = now.getFullYear().toString().slice(-2); //year
  appealCodeDate += ("0" + (now.getMonth() + 1)).slice(-2); //2-digit month

  var member = fetchMemberInfo();
  if(member!==null && typeof member.source !== "unedfined" && member.source !== null && member.source != ""){
    var dmRegex = /^dm/i;
    var textRegex = /^text/i;
    if(dmRegex.test(member.source)){
      return "DNH" + appealCodeDate + "777"; //Direct Mail appeal code
    }
    if(textRegex.test(member.source)){
      return "DNH" + appealCodeDate + "888"; //Text campaign appeal code
    }
  }
  return "DNW" + appealCodeDate + "999"; //default generic donation
}
function getAccountingTopic(){
  var topic = $('.kimbiaDonationForm').attr('data-topic');
  if(typeof topic === 'undefined' || topic === null || topic === ''){
    return null;
  }else{
    return topic;
  }
}
function displayStoredTokenForm(){
  $(".noStoredCard").hide();
  $(".storedCard").show();
  var member = fetchMemberInfo();
  if(typeof fillInStoredInfo !== 'undefined')
    fillInStoredInfo(member);
  $(".storedDonateButton").show();
  $(".kimbiaDiv").hide();
}
function hideStoredTokenForm(){
  $(".noStoredCard").show();
  $(".storedCard").hide();
  $(".storedDonateButton").hide();
  $(".kimbiaDiv").show();
}
$('.stopStoredDonate').click(function(e){
  e.preventDefault();
  hideStoredTokenForm();
});
var storedTokenResponseKey=null;
function getDonationAmount(referenceElement){
  var amountDiv = $(referenceElement).parents('.kimbiaDonationForm').find('.donationAmounts .current');
  if(amountDiv.length == 0)
    amountDiv = $(referenceElement).parents('.kimbiaDonationForm').find('#customAmount');
  var amount = amountDiv.text();
  if(amount == '')
    amount = amountDiv.val();
  if(amount == '')
    amount = amountDiv.children().first().val();
  if(typeof amount == 'undefined' || amount == null || amount == '')
    return 0;
  amount=amount.replace(/[^0-9.]/g, '');
  try{
    amount = parseFloat(amount);
  }catch(e){
    return 0;
  }
  return amount;
}
function reportDonation(charge,time,id){
  dataLayer.push({
      'event': 'Donation',

      /* Google Analytics Transaction */
      /* https://www.analyticsmania.com/post/ecommerce-tracking-with-google-tag-manager/ */
      'transactionId': id,
      'transactionTotal': charge,
      'transactionProducts': [{
          'id': id,
          'name': 'Donation',
          'price': charge,
          'quantity': 1
      }],


      /* Custom variables used for FB Pixel, Taboola, etc. */
      'donation_charge': charge,
      'donation_currency': 'USD',
      'kimbia_transaction_code': id
  })
}
var guid = (function() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
               .toString(16)
               .substring(1);
  }
  return function() {
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
           s4() + '-' + s4() + s4() + s4();
  };
})();
//---VIDEO WIDGET---
$(function(){
  $('.subVideo').click(function(e){
    e.preventDefault();
    var vidFrame = $(this).closest('.contentItem.video').find('.videoContainer iframe');
    var vidImg = $(this).find('img');

    var videoImg = JSON.parse(vidImg.attr('data-video')); //note: swapping this into the frame
    var videoFrame = JSON.parse(vidFrame.attr('data-video')); //note: swapping this into the img
    var vidTitle = $(this).closest('.contentItem.video').find('.videoDesc .title h2');
    var vidTimestamp = $(this).closest('.contentItem.video').find('.videoDesc .timestamp');

    if(videoFrame.youtube){
      videoImg.youtube = true;
      vidFrame.attr('src', 'https://youtube.com/embed/'+ videoImg.token +'?rel=0');
      vidFrame.attr('data-video',JSON.stringify(videoImg));
      vidImg.attr('src','https://img.youtube.com/vi/' + videoFrame.token + '/mqdefault.jpg');
      vidImg.attr('data-video', JSON.stringify(videoFrame));
      vidTitle.text(videoImg.title);
    }else{
      vidFrame.attr('src','https://player.vimeo.com/video/' + videoImg.token);
      vidFrame.attr('data-video',JSON.stringify(videoImg));
      vidImg.attr('src',videoFrame.image);
      vidImg.attr('data-video',JSON.stringify(videoFrame));
      vidTitle.text(videoImg.name);
    }
    vidTimestamp.text(videoImg.published);
    processTimestamp(vidTimestamp)

  })
});
$('.displayKimbiaSecurityInfo').click(function(e){
  e.preventDefault();
  var info = '<p><span class="" secureheading""="">Transaction Security</span><br>' +
    'All communications initiated by this form are transmitted via Secure Sockets Layer (SSL). The SSL protocol is the industry standard method for creating an encrypted, secure connection between your web browser and a web server.</p><p><strong>About This Form</strong><br>' +
    'American Center for Law and Justice has partnered with Kimbia, Inc. to assist in the processing of transactions.</p><p><strong>About Kimbia</strong><br>' +
    '<img src="" https:="" widgets.kimbia.com="" widgets="" form="" img="" kimbia_logo_horizsmall.gif""="" alt="" ""=""><br>' +
    '<strong>Kimbia, Inc.</strong><br>' +
    '1050 E. 11th St<br>Suite 200<br>Austin, TX 78702</p><p>This form is secure. If you would like to see this secure form on its own page, please follow the link below.<br>' +
    '<a href="https://secure.kimbia.com/secure/B44LGPETXE">https://secure.kimbia.com/secure/B44LGPETXE</a></p><p><strong>About American Center for Law and Justice</strong><br>' +
    'American Center for Law and Justice<br>' +
    'PO BOX 90555<br>Washington, DC  20090<br></p>';
  var popup = $('#popupModal');
  popup.find('.modal-title').text('Security Information');
  var modalBody = popup.find('.modal-body');
  modalBody.empty();
  modalBody.append(info);
  popup.modal('show');
})

var processVimeoImg = function(){
  var image = $(this);
  var id = $(image).attr('id');
  if(typeof id !== 'undefined' && id !== null && id.match("vimeo")){
    var token = (id.split("-"))[1];
    var url = "https://vimeo.com/api/v2/video/"+token+".json?callback=showThumb";
    var script = document.createElement('script');
    script.src = url;
    $("#"+id).before(script);
  }
}
function showThumb(data){
  var id_img = "#vimeo-" + data[0].id;
  $(id_img).attr('src',data[0].thumbnail_medium);
}
var successDisplay = function(title,msg, scrollTo){
  if(scrollTo){
    acljScrollTo(scrollTo);
    swal({
      title: title,
      text: msg,
      type: "success"
    },
    function(){
      acljScrollTo(scrollTo);
    })
  }else{
    swal(title,msg,"success");
  }
}
var warnDisplay = function(title,msg){
  if(typeof msg === "undefined"){
    msg=title;
    swal(msg,"warning")
  }else{
    swal(title,msg,"warning");
  }
}
var errorDisplayAndTrack = function(msg,err,customError){
  if(customError)
    console.error(customError); //NOTE: get's picked up by elastic apm.
  else
    console.error(msg);
  swal("Error...",msg,"error");
}

// https://raw.githubusercontent.com/stripe/jquery.payment/master/lib/jquery.payment.js
// minified here: //cdnjs.cloudflare.com/ajax/libs/jquery.payment/1.2.1/jquery.payment.min.js
$('input.accountNumber').payment('formatCardNumber');

$(function(){
  var email = queryString.getQueryVariable('email');
  var token = queryString.getQueryVariable('token');
  var list = queryString.getQueryVariable('resubList');
  if(typeof list !== 'undefined' && list !== null && list !== "" && typeof email !== 'undefined' && email !== null && email !== ""){
    runResubscribe(email,list,token);
  }
})
function runResubscribe(email,list,token){
  list = list.split('_');
  var filteredList=[];
  for(var i=0;i<list.length;i++){
    if(['daily','newsletter','fundRaising','specialAnnouncements','bookAnnouncements'].indexOf(list[i]) > -1){
      filteredList.push(list[i]);
    }
  }
  $.ajax({
    type:"POST",
    url: '/subscriptions/resubscribe',
    data: {filteredList:filteredList,email:email,token:token},
    success: function(data){
      if(data.success){
        successDisplay("Thank You!","Thank you for resubscribing!");
        dataLayer.push({'event': 'Email List Resubscribed'}) // Google Tag Manager 'Email List Resubscribed' Trigger
      }else{
        errorDisplayAndTrack("There was an error re-subscribing. Please try again.");
      }
    },
    dataType: "json"
  });
}
// Production steps of ECMA-262, Edition 5, 15.4.4.14
// Reference: http://es5.github.io/#x15.4.4.14
if (!Array.prototype.indexOf) {
  Array.prototype.indexOf = function(searchElement, fromIndex) {
    var k;
    if (this == null) {
      throw new TypeError('"this" is null or not defined');
    }
    var o = Object(this);
    var len = o.length >>> 0;
    if (len === 0) {
      return -1;
    }
    var n = +fromIndex || 0;
    if (Math.abs(n) === Infinity) {
      n = 0;
    }
    if (n >= len) {
      return -1;
    }
    k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);
    while (k < len) {
      if (k in o && o[k] === searchElement) {
        return k;
      }
      k++;
    }
    return -1;
  };
}

//NOTE:bootstrap tooltip init
$(function () {
  $('[data-toggle="tooltip"]').tooltip()
})
var mobileCheck = function() {
  var check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};
var redditConversion = function(){
  var i=new Image();i.src="https://alb.reddit.com/snoo.gif?q=CAAHAAABAAoACQAAABWchEXFAA==&s=-5jyR95lJgXhHq-oaiOhpGrYToh85905NmA1ZCIswz8=";
}

//CAMPAIGN HELPERS
var isMatchingChallenge = function(){
	var currentDT = new Date();
	var currentMonth = currentDT.getMonth();
	return [2,3,6,7,10,11].indexOf(currentMonth)!=-1;
}
var isDeadline = function(){
	var currentDT = new Date();
	var deadlineDT = new Date(currentDT.getFullYear(), currentDT.getMonth() + 1,-1)
	var currentDay = currentDT.getDate();
	var deadlineDay = deadlineDT.getDate();
	if(currentDay >= deadlineDay)
		return true;

	return false;
}
var isYearEnd = function(){
	var currentDT = new Date();
	var deadlineDT = new Date(currentDT.getFullYear(), 11,1)
	if(currentDT >= deadlineDT)
		return true;

	return false;
}
var getCampaignImage = function(config){
	if(typeof config.image === 'string' && config.image !== '')
		return config.image;
	else if(typeof config.images === 'object' && config.images.length){
		for(var i = 0; i < config.images.length; i++){
			if(typeof config.images[i] === 'object' && typeof config.images[i].image === 'string'){
				if(typeof config.images[i].checkMethod === 'function' && !config.images[i].checkMethod())
					continue;
				return config.images[i].image;
			}
		}
	}
	return '';
}
var formatCampaignUrl = function(source, config){
  if(typeof config.campaignUrl !== 'string' || typeof config.campaignUrl === '')
    return "#";
  else if(config.skipUTM) // Return url without source or campaign utms
    return config.campaignUrl
  else{
    var url = config.campaignUrl;
    if(url.match(/\?[^=]+\=[^&]+/)) url += "&";
    else url += "?";
    url += "utm_source="+source+"&utm_campaign=" + config.campaignName;
    return url;
  }
}
var memberLoggedInWithIncompleteAddress = function(){
  var member = fetchMemberInfo();
  if(typeof member !== 'undefined' && member !== null && typeof member.sessionKey !== 'undefined'){
    var status = sharedFunctions.addressCompleted(member);
    if(status !== 'complete') return true;
  }
  return false;
}
var getMatchingTTLDate = function(){
  var d = new Date();
  var secondToLastDate = new Date(d.getFullYear(), d.getMonth() + 1,-1);
  var ninethToLastDate = new Date(d.getFullYear(), d.getMonth() + 1,-8);
  //checks if seven days before deadline popup change and expires cookie two days before end of month
  if(ninethToLastDate.getDate() <= d.getDate() && d.getDate() < secondToLastDate.getDate()){
    return secondToLastDate;
  } else {
    d.setTime(d.getTime() + 7*24*60*60*1000); //7 days to live
    return d;
  }
}
var getTTLDate = function(daysFromNow){
  var d = new Date();
  d.setTime(d.getTime() + daysFromNow*24*60*60*1000); //Days to live
  return d;
}